import React from 'react';
import './index.css';
import { RequestJSON } from '../../@types/requestJson/RequestJSON';
import { ResponseJSON } from '../../@types/responseJson/ResponseJSON';

type MyProps = {
    displayOfferJSON: boolean,
    requestJson: RequestJSON,
    productTypes: Array<string>,
    responseJSON: ResponseJSON,
    pendingOffers: boolean,
    step1JSON?: ResponseJSON,
    step2JSON?: ResponseJSON,
    pendingStep?: number
}

class JsonConsole extends React.Component<MyProps, {}>{
    
    public render(){
        var textarea = null;
        if(this.props.pendingOffers){
            if(this.props.pendingStep === 1){
                var step1Json = JSON.stringify(this.props.step1JSON, null, 4);
                textarea = (<textarea readOnly id="console" className="JsonDisplay" rows={50} value={step1Json}/>);
            }
            else if(this.props.pendingStep === 2){
                var step2Json = JSON.stringify(this.props.step2JSON, null, 4);
                textarea = (<textarea readOnly id="console" className="JsonDisplay" rows={50} value={step2Json}/>);
            }
            else{
                textarea = (<textarea readOnly id="console" className="JsonDisplay" rows={50} value={"Posting to EVEN API.\nhttps://api.evenfinancial.com/leads\n\nWaiting for offers to be returned."}/>);
            }
        }
        else{
            if(this.props.displayOfferJSON){   
                var displayResponseJSON = JSON.stringify(this.props.responseJSON, null, 4);
                textarea = (<textarea readOnly id="console" className="JsonDisplay" rows={50} value={displayResponseJSON}/>);
            }
            else{
                var requestJson = JSON.stringify(this.props.requestJson, null, 4);
                textarea = (<textarea readOnly id="console" className="JsonDisplay" rows={50} value={requestJson}/>);
            }
        }

        return(
            <div className="borderBox">
                {textarea}
            </div>
        );
    }
}

export default JsonConsole;